import React from 'react'
import { Edit, required, SimpleForm, TextInput, useNotify, useRedirect, useTranslate } from 'react-admin'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { Grid } from '@mui/material'

export const BusinessTypeEdit = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()

  const onSuccess = () => {
    notify('ra.notification.updated_success_masculine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.business-type') }
    })
    redirect('/business-type')
  }

  const onError = () => {
    notify('ra.notification.updated_error_masculine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.business-type') }
    })
  }

  return (
    <Edit {...props} mutationMode='pessimistic' mutationOptions={{ onSuccess, onError }} actions={null}>
      <CardCommon title={translate('ra.title.update_businessType')}>
        <SimpleForm toolbar={<CardCrudBottomButtons btnSave={true} btnDelete={true} fieldsName={['short_name']} genderElement='masculine' />}>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.id')}>
              <TextInput disabled source='id' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.short_name')} required>
              <TextInput source='short_name' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.long_name')} required>
              <TextInput source='long_name' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.tma_code')} required>
              <TextInput source='tma_code' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Edit>
  )
}
